import { render, staticRenderFns } from "./BillingCity.vue?vue&type=template&id=f3516a48&scoped=true"
import script from "./BillingCity.vue?vue&type=script&lang=js"
export * from "./BillingCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3516a48",
  null
  
)

export default component.exports